import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import "@/App.css";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Booking from "@/pages/Booking";
import MyAppointments from "@/pages/MyAppointments";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminAppointments from "@/pages/admin/AdminAppointments";
import Agenda from "@/pages/admin/Agenda";
import Clients from "@/pages/admin/Clients";
import Services from "@/pages/admin/Services";
import Barbers from "@/pages/admin/Barbers";
import Financial from "@/pages/admin/Financial";
import Marketing from "@/pages/admin/Marketing";
import Products from "@/pages/admin/Products";
import WorkingHours from "@/pages/admin/WorkingHours";
import Settings from "@/pages/admin/Settings";

function Protected({ children, admin }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen bg-background" />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Auth />} />
            <Route path="/register" element={<Auth register />} />
            <Route path="/esqueci-senha" element={<ForgotPassword />} />
            <Route path="/redefinir-senha" element={<ResetPassword />} />
            <Route path="/agendar" element={<Protected><Booking /></Protected>} />
            <Route path="/meus-agendamentos" element={<Protected><MyAppointments /></Protected>} />
            <Route path="/admin" element={<Protected admin><AdminLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="agendamentos" element={<AdminAppointments />} />
              <Route path="agenda" element={<Agenda />} />
              <Route path="clientes" element={<Clients />} />
              <Route path="servicos" element={<Services />} />
              <Route path="barbeiros" element={<Barbers />} />
              <Route path="financeiro" element={<Financial />} />
              <Route path="marketing" element={<Marketing />} />
              <Route path="produtos" element={<Products />} />
              <Route path="horarios" element={<WorkingHours />} />
              <Route path="configuracoes" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
